module.exports = __webpack_public_path__ + "img/flow.caae340f.png";